import $ from 'jquery';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------
import {
  forEach as _forEach
} from 'lodash-es';
const baseClass = 'contact-button';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class ContactBar {
  constructor(el) {
    this.el = el;
    this.$ariaControls = $(el).attr('aria-controls');
    this.intersectingElements = new Set();

    this.observer();
  }

  observer() {
    const observerElement = $('#footer');

    const contentObserver = new IntersectionObserver(elements => {
      for (const element of elements) {
        if (element.isIntersecting) {
          this.intersectingElements.add(element.target);
        } else {
          this.intersectingElements.delete(element.target);
        }
      }

      if (this.intersectingElements.size > 0) {
        $(`.${baseClass}`).addClass('visible-footer');
        $(`.scroll-to-top`).addClass('scroll-to-top--footer')
      } else {
        $(`.${baseClass}`).removeClass('visible-footer');
        $(`.scroll-to-top`).removeClass('scroll-to-top--footer')
      }
    }, {rootMargin: "0%"});

    _forEach(observerElement, (item) => {
      contentObserver.observe(item);
    });
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new ContactBar(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
